import * as React from "react";
import Svg, { G, Path } from "react-native-svg";
const CloseIcon = (props: any) => (
  <Svg
    width={16}
    height={16}
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <G opacity={0.4}>
      <Path
        d="M8.00039 8.6999L4.50039 12.1999C4.40039 12.2999 4.28372 12.3499 4.15039 12.3499C4.01706 12.3499 3.90039 12.2999 3.80039 12.1999C3.70039 12.0999 3.65039 11.9832 3.65039 11.8499C3.65039 11.7166 3.70039 11.5999 3.80039 11.4999L7.30039 7.9999L3.80039 4.4999C3.70039 4.3999 3.65039 4.28324 3.65039 4.1499C3.65039 4.01657 3.70039 3.8999 3.80039 3.7999C3.90039 3.6999 4.01706 3.6499 4.15039 3.6499C4.28372 3.6499 4.40039 3.6999 4.50039 3.7999L8.00039 7.2999L11.5004 3.7999C11.6004 3.6999 11.7171 3.6499 11.8504 3.6499C11.9837 3.6499 12.1004 3.6999 12.2004 3.7999C12.3004 3.8999 12.3504 4.01657 12.3504 4.1499C12.3504 4.28324 12.3004 4.3999 12.2004 4.4999L8.70039 7.9999L12.2004 11.4999C12.3004 11.5999 12.3504 11.7166 12.3504 11.8499C12.3504 11.9832 12.3004 12.0999 12.2004 12.1999C12.1004 12.2999 11.9837 12.3499 11.8504 12.3499C11.7171 12.3499 11.6004 12.2999 11.5004 12.1999L8.00039 8.6999Z"
        fill="#1C2024"
        stroke="black"
      />
    </G>
  </Svg>
);
export default CloseIcon;
